module.exports = __webpack_public_path__ + "img/settings.cbdd0681.svg";